export default __webpack_public_path__ + "static/media/Experience Selector.8738c9e5.svg";